import PropTypes from "prop-types"; 
import React from 'react';
import {Link} from "react-router-dom";
import { useState, useEffect } from "react";


const Logo = ({image,LogoText,LogoFooterText,MobileMenuText}) => {
    const [scroll, setScroll] = useState(0);
    const [headerTop, setHeaderTop] = useState(0);

    useEffect(() => {
        const header = document.querySelector(".logoClass");
        setHeaderTop(header.offsetTop);
        window.addEventListener("scroll", handleScroll);
        return () => {
        window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = () => {
        setScroll(window.scrollY);
    };

    return(
        // <div className="header-logo" style={{marginTop:'10px'}}>
        <div className="logoClass" style={{marginTop:''}}>
            <Link to={process.env.PUBLIC_URL + "/"}>
                {image?  <img style={{ marginTop:'5px'}} className= {`dark-logo logoClass ${scroll > headerTop ? "logoResize" : ""}`}   id="changeOnScroll" src={process.env.PUBLIC_URL + image} alt="Ikabit Logo"/> : ''}
                {LogoText? <span  className= {`logo-color  ${scroll > headerTop ? "logoTextResize" : ""}`} id="logoTextResize" style={{verticalAlign:'middle'}}>{LogoText}</span> : ''}
                {LogoFooterText? <span  className= "footerLogo">{LogoFooterText}</span> : ''}
                {MobileMenuText? <span  style={{color:'#fff', fontWeight:700, fontSize:'1.5rem'}}>{MobileMenuText}</span> : ''}

            </Link>
        </div>
    )
}

Logo.propTypes = {
    image: PropTypes.string,
    MobileMenuText : PropTypes.string,
    LogoText: PropTypes.string,
    LogoFooterText: PropTypes.string
};

export default Logo;
